<div class="header_second col-12">
    <div class="Dashboard_head">
        <div class="page_identity">
            <span class="page_title">Dashboard</span>
            <span class="page_subtitle">{{ dashboardModeLabel }}</span>
        </div>

        <div class="page_status">
            <span class="status_badge" *ngIf="canViewEventAnalytics">
                {{ registrationStatusLabel }} registration
            </span>
            <span class="status_badge" [ngClass]="isLoading ? 'status-loading' : 'status-live'">
                <span class="status_dot"></span>
                {{ lastUpdated ? (isLoading ? 'Refreshing data' : ('Updated ' + (lastUpdated | date:'shortTime'))) :
                'Loading data' }}
            </span>
        </div>
    </div>
</div>

<section class="container-fluid custom-container">
    <div class="summary-grid" *ngIf="summaryMetrics.length">
        <article class="summary-card clickable-card" *ngFor="let metric of summaryMetrics"
            [ngClass]="'tone-' + metric.tone" (click)="onSummaryCardClick(metric.label)">
            <div class="summary-icon">
                <mat-icon>{{ metric.icon }}</mat-icon>
            </div>
            <div class="summary-body">
                <span class="summary-label">{{ metric.label }}</span>
                <strong class="summary-value">{{ metric.value }}</strong>
                <p class="summary-helper">{{ metric.helper }}</p>
            </div>
        </article>
    </div>

    <app-dashboard-section *ngIf="canViewEventAnalytics" title="Registration Funnel" icon="assignment_ind"
        color="primary">
        <div class="panel-grid">
            <!-- <div class="panel-card">
                <app-chart-widget title="Registration Trend" chartType="bar" [chartData]="registrationTrendData">
                </app-chart-widget>
            </div> -->

            <div class="info-card">
                <div class="info-card-header">
                    <h3>Quick summary</h3>
                    <span class="status-pill" [ngClass]="registrationOpen ? 'tone-success' : 'tone-warning'">
                        {{ registrationStatusLabel }}
                    </span>
                </div>

                <div class="info-list">
                    <div class="info-row">
                        <span>Total registrations</span>
                        <strong>{{ registrations | number:'1.0-0' }}</strong>
                    </div>
                    <div class="info-row">
                        <span>Approved</span>
                        <strong>{{ approvedRegistrations | number:'1.0-0' }}</strong>
                    </div>
                    <div class="info-row">
                        <span>Pending approval</span>
                        <strong>{{ pending_registrations | number:'1.0-0' }}</strong>
                    </div>
                    <div class="info-row">
                        <span>Not visited</span>
                        <strong>{{ totalNotVisited | number:'1.0-0' }}</strong>
                    </div>
                    <div class="info-row">
                        <span>Checked in</span>
                        <strong>{{ checkins | number:'1.0-0' }}</strong>
                    </div>
                    <div class="info-row">
                        <span>Checked out</span>
                        <strong>{{ checkouts | number:'1.0-0' }}</strong>
                    </div>
                </div>
            </div>

            <div class="info-card">
                <div class="info-card-header">
                    <h3>Scan summary</h3>
                    <span class="status-pill tone-info">{{ active_scanning_points | number:'1.0-0' }} points</span>
                </div>

                <div class="info-list">
                    <!-- <div class="info-row">
                                    <span>Active checkpoints</span>
                                    <strong>{{ active_scanning_points | number:'1.0-0' }}</strong>
                                </div>
                                <div class="info-row">
                                    <span>Active participants</span>
                                    <strong>{{ active_participants | number:'1.0-0' }}</strong>
                                </div> -->
                    <div class="info-row">
                        <span>Total scans</span>
                        <strong>{{ totalScannerActions | number:'1.0-0' }}</strong>
                    </div>
                    <div class="info-row">
                        <span>Check in scans</span>
                        <strong>{{ checkins | number:'1.0-0' }}</strong>
                    </div>
                    <div class="info-row">
                        <span>Check out scans</span>
                        <strong>{{ checkouts | number:'1.0-0' }}</strong>
                    </div>
                </div>
            </div>

            <div class="info-card">
                <div class="info-card-header">
                    <h3>Category summary</h3>
                    <span class="status-pill tone-primary">{{ ticket_category_attendance.length }} categories</span>
                </div>

                <div class="info-list">
                    <div class="info-row">
                        <span>Total registrations</span>
                        <strong>{{ registrations | number:'1.0-0' }}</strong>
                    </div>
                    <div class="info-row">
                        <span>Visited</span>
                        <strong>{{ checkins | number:'1.0-0' }}</strong>
                    </div>
                    <div class="info-row">
                        <span>Not visited</span>
                        <strong>{{ totalNotVisited | number:'1.0-0' }}</strong>
                    </div>
                    <div class="info-row">
                        <span>Checkpoint-category rows</span>
                        <strong>{{ checkpoint_category_scans.length | number:'1.0-0' }}</strong>
                    </div>
                </div>
            </div>
        </div>
    </app-dashboard-section>

    <app-dashboard-section *ngIf="canViewEventAnalytics" title="Ticket Category Movement" icon="sell" color="info">
        <div class="panel-grid">
            <!-- <div class="panel-card">
                <app-chart-widget title="Visited vs Not Visited by Ticket Category" chartType="bar"
                    [chartData]="ticketCategoryAttendanceChartData">
                </app-chart-widget>
            </div> -->

            <!-- <div class="info-card">
                <div class="info-card-header">
                    <h3>Category summary</h3>
                    <span class="status-pill tone-primary">{{ ticket_category_attendance.length }} categories</span>
                </div>

                <div class="info-list">
                    <div class="info-row">
                        <span>Total registrations</span>
                        <strong>{{ registrations | number:'1.0-0' }}</strong>
                    </div>
                    <div class="info-row">
                        <span>Visited</span>
                        <strong>{{ checkins | number:'1.0-0' }}</strong>
                    </div>
                    <div class="info-row">
                        <span>Not visited</span>
                        <strong>{{ totalNotVisited | number:'1.0-0' }}</strong>
                    </div>
                    <div class="info-row">
                        <span>Checkpoint-category rows</span>
                        <strong>{{ checkpoint_category_scans.length | number:'1.0-0' }}</strong>
                    </div>
                </div>
            </div> -->
        </div>

        <div class="table-grid">
            <div class="table-card">
                <div class="table-card-header">
                    <h3>By ticket category</h3>
                </div>

                <div class="table-wrapper" *ngIf="ticket_category_attendance.length; else noCategorySummary">
                    <table class="simple-table">
                        <thead>
                            <tr>
                                <th>Category</th>
                                <th>Registered</th>
                                <th>Check In</th>
                                <th>Check Out</th>
                                <th>Not Visited</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of ticket_category_attendance" class="clickable-row"
                                (click)="onTicketCategoryClick(item)">
                                <td>
                                    <strong>{{ item.category }}</strong>
                                    <span class="cell-subtext">{{ item.visitRate }}% visited</span>
                                </td>
                                <td>{{ item.total_reg | number:'1.0-0' }}</td>
                                <td>{{ item.checkins | number:'1.0-0' }}</td>
                                <td>{{ item.checkouts | number:'1.0-0' }}</td>
                                <td>{{ item.not_visited | number:'1.0-0' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <ng-template #noCategorySummary>
                    <div class="empty-panel">
                        <mat-icon>sell</mat-icon>
                        <p>No ticket category summary available yet.</p>
                    </div>
                </ng-template>
            </div>

            <!-- <div class="table-card">
                <div class="table-card-header">
                    <h3>By checkpoint and category</h3>
                </div>

                <div class="table-wrapper" *ngIf="checkpoint_category_scans.length; else noCheckpointCategoryScans">
                    <table class="simple-table">
                        <thead>
                            <tr>
                                <th>Checkpoint</th>
                                <th>Category</th>
                                <th>Total Scans</th>
                                <th>Check In</th>
                                <th>Check Out</th>
                                <th>Visitors</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of checkpoint_category_scans">
                                <td>{{ item.checkpoint }}</td>
                                <td>{{ item.category }}</td>
                                <td>{{ item.totalScans | number:'1.0-0' }}</td>
                                <td>{{ item.checkins | number:'1.0-0' }}</td>
                                <td>{{ item.checkouts | number:'1.0-0' }}</td>
                                <td>{{ item.uniqueVisitors | number:'1.0-0' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <ng-template #noCheckpointCategoryScans>
                    <div class="empty-panel">
                        <mat-icon>table_chart</mat-icon>
                        <p>No checkpoint category scans recorded yet.</p>
                    </div>
                </ng-template>
            </div> -->
        </div>
    </app-dashboard-section>

    <app-dashboard-section *ngIf="canViewEventAnalytics" title="Checkpoint Scanning" icon="qr_code_scanner"
        color="success">
        <div class="panel-grid">
            <!-- <div class="panel-card">
                    <app-chart-widget title="Scans by Checkpoint" chartType="bar" [chartData]="checkpointScansChartData">
                    </app-chart-widget>
                </div> -->

            <!-- <div class="info-card">
                    <div class="info-card-header">
                        <h3>Scan summary</h3>
                        <span class="status-pill tone-info">{{ active_scanning_points | number:'1.0-0' }} points</span>
                    </div>
    
                    <div class="info-list">
                        <div class="info-row">
                            <span>Active checkpoints</span>
                            <strong>{{ active_scanning_points | number:'1.0-0' }}</strong>
                        </div>
                        <div class="info-row">
                            <span>Active participants</span>
                            <strong>{{ active_participants | number:'1.0-0' }}</strong>
                        </div>
                        <div class="info-row">
                            <span>Total scans</span>
                            <strong>{{ totalScannerActions | number:'1.0-0' }}</strong>
                        </div>
                        <div class="info-row">
                            <span>Check in scans</span>
                            <strong>{{ checkins | number:'1.0-0' }}</strong>
                        </div>
                        <div class="info-row">
                            <span>Check out scans</span>
                            <strong>{{ checkouts | number:'1.0-0' }}</strong>
                        </div>
                    </div>
                </div> -->
        </div>

        <div class="table-card">
            <div class="table-card-header enhanced-header">
                <div class="header-left">
                    <h3>Staff scanner activity</h3>
                    <span class="row-count">{{ filteredScannerActivity.length }} rows</span>
                </div>

                <div class="table-controls enhanced-controls">
                    <div class="search-box">
                        <mat-icon>search</mat-icon>
                        <input type="text" placeholder="Search staff, mobile, checkpoint..." [(ngModel)]="searchTerm"
                            (input)="applyFilterAndSort()" />
                    </div>
                </div>
            </div>

            <div class="table-wrapper" *ngIf="scanner_activity.length; else noScannerActivity">
                <table class="simple-table">
                    <thead>
                        <tr>
                            <th (click)="sortBy('user_name')">Staff <span *ngIf="sortColumn === 'user_name'">
                                    {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                </span></th>
                            <th (click)="sortBy('date')"> Date <span *ngIf="sortColumn === 'date'">
                                    {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                </span></th>
                            <th (click)="sortBy('checkpoint')">Checkpoint <span *ngIf="sortColumn === 'checkpoint'">
                                    {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                </span></th>
                            <th (click)="sortBy('checkins')">Check In <span *ngIf="sortColumn === 'checkins'">
                                    {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                </span></th>
                            <th (click)="sortBy('checkouts')">Check Out <span *ngIf="sortColumn === 'checkouts'">
                                    {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                </span></th>
                            <th (click)="sortBy('last_scan_at')">Last Scan <span *ngIf="sortColumn === 'last_scan_at'">
                                    {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                </span></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of filteredScannerActivity" class="clickable-row"
                            (click)="onScannerActivityClick(item)">
                            <td>
                                <strong>{{ item.user_name }}</strong>
                                <span class="cell-subtext" *ngIf="item.user_mobile">{{ item.user_mobile }}</span>
                            </td>
                            <td>{{ item.date }}</td>
                            <td>{{ item.checkpoint }}</td>
                            <!-- <td>{{ item.totalScans | number:'1.0-0' }}</td> -->
                            <td>{{ item.checkins | number:'1.0-0' }}</td>
                            <td>{{ item.checkouts | number:'1.0-0' }}</td>
                            <td>{{ item.last_scan_at }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <ng-template #noScannerActivity>
                <div class="empty-panel">
                    <mat-icon>qr_code_scanner</mat-icon>
                    <p>No scanner activity yet.</p>
                </div>
            </ng-template>
        </div>
    </app-dashboard-section>

    <app-dashboard-section *ngIf="canViewSystemAnalytics" title="Platform Overview" icon="insights" color="primary">
        <div class="info-card info-card-full">
            <div class="info-card-header">
                <h3>Event selection needed</h3>
            </div>
            <p class="info-note">
                Select an event from the admin flow to see the simple registration and checkpoint scanning dashboard.
            </p>
        </div>
    </app-dashboard-section>

    <app-dashboard-section *ngIf="role == 'stallowner'" title="Stall Workspace" icon="store" color="success">
        <div class="workspace-card">
            <div>
                <h3>Manage your stall storefront</h3>
                <p>Open your stall area to update details and keep your event setup ready.</p>
            </div>
            <button mat-flat-button color="primary" routerLink="/admin/My Stall">Open My Stall</button>
        </div>
    </app-dashboard-section>

    <app-dashboard-section *ngIf="role == 'user'" title="Catalogue Workspace" icon="inventory_2" color="info">
        <div class="workspace-card">
            <div>
                <h3>Manage your catalogue</h3>
                <p>Open your catalogue area to update products and shop details.</p>
            </div>
            <button mat-flat-button color="primary" routerLink="/admin/My Catalogue">Open My Catalogue</button>
        </div>
    </app-dashboard-section>

    <app-dashboard-section *ngIf="canViewEventAnalytics" title="Analytics Charts" icon="bar_chart" color="primary">

        <div class="panel-grid">

            <div class="panel-card">
                <app-chart-widget title="Registration Trend" chartType="bar" [chartData]="registrationTrendData">
                </app-chart-widget>
            </div>

            <div class="panel-card">
                <app-chart-widget title="Scans by Checkpoint" chartType="bar" [chartData]="checkpointScansChartData">
                </app-chart-widget>
            </div>

            <div class="panel-card">
                <app-chart-widget title="Visited vs Not Visited" chartType="bar"
                    [chartData]="ticketCategoryAttendanceChartData">
                </app-chart-widget>
            </div>

        </div>
    </app-dashboard-section>
</section>